import { render, staticRenderFns } from "./reqDetail.vue?vue&type=template&id=40006cd2&scoped=true&"
import script from "./reqDetail.vue?vue&type=script&lang=js&"
export * from "./reqDetail.vue?vue&type=script&lang=js&"
import style0 from "./reqDetail.vue?vue&type=style&index=0&id=40006cd2&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40006cd2",
  null
  
)

export default component.exports